module.exports = __webpack_public_path__ + "media/logo/logo_akatsuki-0c3ee8fc.png";